import * as React from 'react';
import { motion } from 'framer-motion';
import { MobileNavItem } from './MobileNavItem';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

const variants = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 },
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 },
  },
};
const Items = [
  {
    id: '0',
    element: (
      <a
        href='https://employers.belong.education/'
        target='_blank'
        rel='noreferrer noopener'
      >
        Employer
      </a>
    ),
  },
  {
    id: '1',
    element: (
      <a
        href='https://universities.belong.education/'
        target='_blank'
        rel='noreferrer noopener'
      >
        University
      </a>
    ),
  },
  {
    id: '2',
    element: (
      <div className='font-poppins font-bold'>
        <Link to='/login'>Login</Link>
      </div>
    ),
  },
  {
    id: '3',
    element: (
      <Link
        to='/signup'
        className='bg-primary/70 rounded-lg px-4 py-1 font-poppins font-bold shadow'
      >
        Signup
      </Link>
    ),
  },
];

export const MobileNavbar: React.FC<{ isOpen: boolean }> = ({ isOpen }) => (
  <>
    <motion.ul
      variants={variants}
      className={classNames(
        ' text-center mt-4 py-8 relative z-10 w-1/2 mx-auto',
        {
          'pointer-events-none': !isOpen,
        }
      )}
    >
      {Items.map((item) => (
        <MobileNavItem key={item.id} element={item.element} />
      ))}
    </motion.ul>
  </>
);
